import { empresaService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const empresaAction = {
    getEmpresa,
    getEmpresaById,
    onChangeProps,
    editEmpresaInfo,
    createEmpresa,
    deleteEmpresaById,
    getEmpresasSelect,
    getEmpresasSelected
};
function getEmpresa(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'empresas';
        empresaService.get(apiEndpoint)
            .then((response) => {
              //  response.data.unshift({ id: '0', nome: ' SELECIONE ...' });
                dispatch(changeEmpresasList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function createEmpresa(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'empresas/';
        empresaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/empresas');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function getEmpresaById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'empresas/' + id;
        empresaService.get(apiEndpoint)
            .then((response) => {
                dispatch(editEmpresasDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

function editEmpresaInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'empresa/' + id;
        empresaService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/empresas');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function deleteEmpresaById(id) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {

                    let apiEndpoint = 'empresas/' + id;
                    empresaService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteEmpresasDetails());
                                dispatch(empresaAction.getEmpresa());
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })

                }
            });


    };
}

function getEmpresasSelect() {
    return dispatch => {
        let apiEndpoint = 'empresas/select';
        empresaService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Text: 'SELECIONE...', Value: '' })
                dispatch(changeEmpresasList(response.data));
              //  console.log("response.data", response.data)
            }).catch((err) => {
                console.log(err);
            })
    };
}

function getEmpresasSelected() {
    return dispatch => {
        let apiEndpoint = 'empresas/selected';
        empresaService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Text: 'SELECIONE...', Value: '' })
                dispatch(changeEmpresasList(response.data));
                //  console.log("response.data", response.data)
            }).catch((err) => {
                console.log(err);
            })
    };
}
export function changeEmpresasList(empresa) {
    return {
        type: "FETECHED_ALL_EMPRESA",
        empresa: empresa
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editEmpresasDetails(empresa) {
    return {
        type: "EMPRESA_DETAIL",
        id: empresa.id,
        nome: empresa.nome,
        estoque_integrado: empresa.estoque_integrado,
        caminho_logo: empresa.caminho_logo,
        data_cadastro: empresa.data_cadastro,
        usuario_cadastro: empresa.usuario_cadastro,
        data_exclusao: empresa.data_exclusao,
        usuario_exclusao: empresa.usuario_exclusao

    }
}
export function updatedUserInfo() {
    return {
        type: "EMPRESA_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "EMPRESA_CREATED_SUCCESSFULLY"
    }
}
export function deleteEmpresasDetails() {
    return {
        type: "DELETED_EMPRESA_DETAILS"
    }
}